import React, {useEffect, useState} from "react";
import {Button, Row, Col, Modal, notification, Icon, TimePicker, Checkbox, Dropdown, Form} from "antd";
import {distributionCenterService} from "../../../services";
import InputField from "../../input-field";
import SelectField from "../../select-field";
import '../modals.css';
import moment from "moment";
import FieldBlock from "../../field-block";
import NumberInputField from "../../number-input-field";
import i18n from '../../../i18n';

export default function ModalCreateGateForDistributionCenter({
                                                               isShow, id,
                                                               onCloseModal, nameD,
                                                               gateData, setIsNeedUpdateList,
                                                             }) {

  const [fieldsErrors, setFieldsErrors] = useState(null);

  const [name, setName] = useState('');
  const [serviceTime, setServiceTime] = useState('');
  const [workingDays, setWorkingDays] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isValidated, setIsValidated] = useState(true);
  const [gateType, setGateType] = useState(null);
  const [maxCargoWeight, setMaxCargoWeight] = useState(20000);
  const [gates, setGates] = useState(null);
  const [realGate, setRealGate] = useState(null);
  const namesDay = [
    i18n.t('constants.dayName.1'),
    i18n.t('constants.dayName.2'),
    i18n.t('constants.dayName.3'),
    i18n.t('constants.dayName.4'),
    i18n.t('constants.dayName.5'),
    i18n.t('constants.dayName.6'),
    i18n.t('constants.dayName.7')
  ];

  useEffect(() => {
    if (isShow && id != null) {

      distributionCenterService.getGates(id, null, true)
        .then((response) => {
          if (response != null && response.length > 0) {

            let formattedGates = response;

            if (gateData != null) {
              formattedGates = response.filter((item) => {
                return item.id !== gateData.id;
              })
            }

            formattedGates = formattedGates.map((item) => {
              return {
                id: item.id,
                name: item.name
              }
            })
            setGates(formattedGates);
          }
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.getGates'),
            description: error
          });
        })
    }
  }, [isShow])

  useEffect(() => {
    if (gateData && !isUpdated) {
      setIsActive(gateData.isActive);
      setName(gateData.name);
      setServiceTime(gateData.serviceTime);
      setWorkingDays(gateData.workingDays);
      setGateType(gateData.type)
      setMaxCargoWeight(gateData.maxCargoWeight);
      setIsUpdated(true);
      setRealGate(gateData.realGateId)
    }
  }, [isUpdated])

  useEffect(() => {
    if (name !== '' && serviceTime !== '' && workingDays.length !== 0)
      validateFormData();
  }, [name, serviceTime, workingDays]);

  let bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };

  const gateTypes = [
    {Id:'loading', Name: i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.values.loading')},
    {Id:'unloading', Name: i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.values.unloading')}
  ]
  const clearForm = () => {
    if (!gateData) {
      setIsActive(true);
      setName('');
      setServiceTime('');
      setWorkingDays([]);
      setGateType(null);
      setMaxCargoWeight(20000);
      setRealGate(null);
    }
  }

  // сохранение новых данных
  const onClickAdd = () => {
    if (!gateData) {
      let servTime = serviceTime;
      if (gateType === gateTypes[1].Id) {
        servTime = '1';
      }

      distributionCenterService.addGate(id, isActive, name, servTime, workingDays, gateType, maxCargoWeight, realGate)
        .then((response) => {
          if (response.status === 'success') {
            notification.success({
              message: i18n.t('components.notification.titles.addGate'),
              description: response.message,
            });
            setFieldsErrors(null);
            onCloseModal();
            setIsNeedUpdateList(true);
            clearForm();
          }
          if (response.status === 'error') {
            setFieldsErrors(response.errors);
            notification.error({
              message: i18n.t('components.notification.titles.addGate'),
              description: response.message,
            });
          }
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.addGate'),
            description: error,
          });
        });
    }

    if (gateData) {
      let formatedGateType = gateType === i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.values.loading') ? 'loading' : 'unloading';
      let servTime = '1';

      if (formatedGateType === 'loading') {
        servTime = serviceTime;
      }

      distributionCenterService.editGate(gateData.id, isActive, name, servTime, workingDays, formatedGateType, maxCargoWeight, realGate)
        .then((response) => {
          if (response.status === 'success') {
            notification.success({
              message: i18n.t('components.notification.titles.editGate'),
              description: response.message,
            });
            setFieldsErrors(null);
            onCloseModal();
            setIsNeedUpdateList(true);
            clearForm();
          } else {
            setFieldsErrors(response.errors);
            notification.error({
              message: i18n.t('components.notification.titles.editGate'),
              description: response.message,
            });
          }
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.editGate'),
            description: error,
          });
        });
    }
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const getDefaultValue = (index, nameValue) => {
    if (workingDays.length === 0 || !workingDays.some((item) => item.dayNum === (index + 1))
      || workingDays.find((item) => item.dayNum === (index + 1))[nameValue] === undefined
      || workingDays.find((item) => item.dayNum === (index + 1))[nameValue] === '') {
      return null
    }

    return moment(workingDays.find((item) => item.dayNum === (index + 1))[nameValue], "HH:mm")
  }

  const onChangeTimeValue = (time, timeString, nameValue, index) => {
    if (workingDays.some((item) => item.dayNum === index + 1)) {
      setWorkingDays(workingDays.map((day) => {
          if (day.dayNum === index + 1) {
            return {
              ...day,
              [nameValue]: timeString
            }
          } else {
            return day
          }
        }
      ));
    }
  }

  const validateFormData = () => {
    let errors = {};

    if (name.length < 2) {
      errors = {
        ...errors,
        name: [i18n.t('modals.modalCreateGateForDistributionCenter.errors.name')]
      }
    }

    workingDays.map((item) => {
      if (item.startWorkingTime === '' || item.endWorkingTime === '') {
        errors = {
          ...errors,
          [`workingDay${item.dayNum}`]: [`${namesDay[item.dayNum - 1].toUpperCase()}: ${i18n.t('modals.modalCreateGateForDistributionCenter.errors.emptyWorkingDay')}`]
        }
      }

      if (item.startWorkingTime > item.endWorkingTime || item.startWorkingTime === item.endWorkingTime) {
        errors = {
          ...errors,
          [`workingDay${item.dayNum}`]: [`${namesDay[item.dayNum - 1].toUpperCase()}: ${i18n.t('modals.modalCreateGateForDistributionCenter.errors.workingDay')}`]
        }
      }

      if ((item.startWorkingTime > item.startBreakTime || item.endBreakTime > item.endWorkingTime || item.endBreakTime < item.startBreakTime) && item.endBreakTime !== "" && item.startBreakTime !== "") {
        errors = {
          ...errors,
          [`workingDay${item.dayNum}`]: [`${namesDay[item.dayNum - 1].toUpperCase()}: ${i18n.t('modals.modalCreateGateForDistributionCenter.errors.pause')}`]
        }
      }
    })

    if (Object.keys(errors).length !== 0) {
      setFieldsErrors(errors);
      setIsValidated(false);
    } else {
      setFieldsErrors(null);
      setIsValidated(true);
    }
  };

  return (
    <Modal
      title={gateData ? <span>{i18n.t('modals.modalCreateGateForDistributionCenter.titles.edit', {gateName:gateData.name, nameD:nameD})}</span> :
        <span>{i18n.t('modals.modalCreateGateForDistributionCenter.titles.create', {nameD:nameD})}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
      }}
      forceRender={true}
      footer={[
        <Button htmlType="submit" key="submit" type="primary" onClick={onClickAdd}
                style={bigButtonStyle}
                disabled={!isValidated}
        >{i18n.t('main.buttons.save')}</Button>,
      ]}
    >
      <Row gutter={[8, 16]} align={"bottom"} type="flex" style={{marginBottom: "20px"}}>
        <Col lg={12} md={18} sm={24} xs={24}>
          <InputField
            name="name" label={i18n.t('modals.modalCreateGateForDistributionCenter.fields.name.title')}
            value={name} setValue={setName}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        { gateType != null && gateType !== gateTypes[1].Id && gateType !== 'Разгрузка' &&
        <Col lg={12} md={6} sm={24} xs={24}>
          <InputField
            name="serviceTime" label={i18n.t('modals.modalCreateGateForDistributionCenter.fields.serviceTime.title')}
            value={serviceTime} setValue={setServiceTime}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        }
        <Col lg={24} md={24} sm={24} xs={24}>
          <Checkbox
            defaultChecked={isActive}
            onChange={() => setIsActive(!isActive)}
            style={{height: "100%"}}
          >
            {i18n.t('modals.modalCreateGateForDistributionCenter.fields.isActive.title')}
          </Checkbox>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          {gateData == null ? <SelectField
                name="gateType" title={i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.title')}
                placeholder={i18n.t('modals.modalCreateGateForDistributionCenter.fields.gateType.placeholder')}
                getErrors={() => {
                }}
                onChange={(value) => {
                  setGateType(value)
                }}
                style={{width: "30%"}}
                selectedValue={gateType}
                values={gateTypes}/>
           : null
           }
        </Col>
      </Row>
      {gates !== null &&
        <Row>
          <Col>
            <SelectField
              name={'gates'}
              title={i18n.t('modals.modalCreateGateForDistributionCenter.fields.realGate.title')}
              getErrors={getFieldErrors}
              style={{ width: "100%" }}
              values={gates}
              selectedValue={realGate}
              onChange={(val) => {
                setRealGate(val);
              }}
              allowClear={true}
            />

          </Col>
        </Row>
      }
      <Row>
        <Col>
           <NumberInputField
              name="maxCargoWeight"
              label={i18n.t('modals.modalCreateGateForDistributionCenter.fields.maxCargoWeight.title')}
              value={maxCargoWeight}
              setValue={setMaxCargoWeight}
              getFieldErrors={getFieldErrors}
            />
        </Col>
      </Row>
      <Row gutter={[8, 16]} className="only-desktop">
        <Col xs={24} sm={24} md={6} lg={6} xl={6}></Col>
        <Col xs={24} sm={24} md={9} lg={9} xl={9}><span style={{fontSize: "12px"}}><Icon type="clock-circle"/> {i18n.t('modals.modalCreateGateForDistributionCenter.fields.workingHours.title')}</span></Col>
        <Col xs={24} sm={24} md={9} lg={9} xl={9}><span style={{fontSize: "12px"}}><Icon type="coffee"/> {i18n.t('modals.modalCreateGateForDistributionCenter.fields.pause.title')}</span></Col>
      </Row>
      {
        namesDay.map((day, index) => {
          return <FieldBlock name={`workingDay${index + 1}`} title="" getErrors={getFieldErrors} key={index + 1}
                             style={{margin: "0"}}>
            <Row gutter={[0, 16]}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <Checkbox
                  checked={workingDays.length === 0 ? false : workingDays.some((item) => item.dayNum === (index + 1))}
                  value={index + 1}
                  onChange={(e) => {
                    if (workingDays.length === 0 || !workingDays.some((item) => item.dayNum === e.target.value)) {
                      setWorkingDays(workingDays.concat([{
                        dayNum: e.target.value,
                        startWorkingTime: '',
                        endWorkingTime: '',
                        startBreakTime: '',
                        endBreakTime: ''
                      }]));
                    }

                    if (workingDays.some((item) => item.dayNum === e.target.value)) {
                      setWorkingDays(workingDays.filter((item) => !(item.dayNum === e.target.value)));
                    }
                  }}
                  name={"dayNum"}>
                  {day}
                </Checkbox>
              </Col>
              <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                <TimePicker name="startWorkingTime" format="HH:mm" minuteStep={10} placeholder=""
                            style={{margin: "0 5px"}}
                            defaultOpenValue={moment('08:00', 'HH:mm')}
                            value={getDefaultValue(index, "startWorkingTime")}
                            onChange={(time, timeString) => onChangeTimeValue(time, timeString, "startWorkingTime", index)}
                            disabled={!workingDays.some((item) => item.dayNum === (index + 1))}
                />
                <TimePicker name="endWorkingTime" format="HH:mm" minuteStep={10} placeholder=""
                            style={{margin: "5px"}}
                            defaultOpenValue={moment('18:00', 'HH:mm')}
                            value={getDefaultValue(index, "endWorkingTime")}
                            onChange={(time, timeString) => onChangeTimeValue(time, timeString, "endWorkingTime", index)}
                            disabled={!workingDays.some((item) => item.dayNum === (index + 1))}/>
              </Col>
              <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                <TimePicker name="startBreakTime" format="HH:mm" minuteStep={10} suffixIcon={<Icon type="coffee"/>}
                            placeholder=""
                            style={{margin: "0 5px"}}
                            defaultOpenValue={moment('12:00', 'HH:mm')}
                            value={getDefaultValue(index, "startBreakTime")}
                            onChange={(time, timeString) => onChangeTimeValue(time, timeString, "startBreakTime", index)}
                            disabled={!workingDays.some((item) => item.dayNum === (index + 1))}/>
                <TimePicker name="endBreakTime" format="HH:mm" minuteStep={10} suffixIcon={<Icon type="coffee"/>}
                            placeholder="" style={{margin: "5px"}}
                            defaultOpenValue={moment('14:00', 'HH:mm')}
                            value={getDefaultValue(index, "endBreakTime")}
                            onChange={(time, timeString) => onChangeTimeValue(time, timeString, "endBreakTime", index)}
                            disabled={!workingDays.some((item) => item.dayNum === (index + 1))}/>

              </Col>
            </Row>
          </FieldBlock>
        })
      }
    </Modal>
  );
}
